import React, { Component } from "react";
import { clearErrors } from "../../../actions/errorsActions";
import SideMenuOffices from "../../../components/layout/SideMenuOffices";
import SideMenu from "../../../components/layout/SideMenu";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Navigate from "../../../components/Navigate/Navigate";
import SearchDropdown from "../../../components/common/SearchDropdown";
import TextAreaEditor from "../../../components/common/TextAreaEditor";
import QuestionValidation from "../../../validation/QuestionValidation";
import Btn from "../../../components/common/Btn";
import Switch from "../../../components/common/SwitchComponent";
import Spinner from "../../../components/common/Spinner";
import successToast from "../../../components/toast/successToast";
import failToast from "../../../components/toast/failToast";
import CheckPermissions from "../../../validation/CheckPermissions";
import { pageType } from "../../../enums/pageType";
import { roles } from "../../../enums/roles";
import { getGlobalQuestion, createQuestion } from "../../../actions/questionActions";
import { getUserOffices } from "../../../actions/officeActions";
import { getCategories } from "../../../actions/categoryActions";
import { getDifficulties } from "../../../actions/difficultyActions";
import { EditorState, convertToRaw, ContentState } from "draft-js";
// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import { withRouter } from "react-router-dom";
import isEmpty from "../../../validation/isEmpty";

class CopyQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialRender: true,
      editorStateQuestion: EditorState.createEmpty(),
      editorStateAnswer: EditorState.createEmpty(),
      questionDb: this.props.questions.question,
      userOffices: this.props.offices && this.props.offices.userOffices,
      categories: this.props.categories.categories,
      difficulties: this.props.difficulties.difficulties,
      rolesAllowedToOpen: [roles.SUPERADMINISTRATOR, roles.ADMINISTRATOR],
      difficultiesMapped: [],
      requestLoading: false,
      officesMapped: [],
      categoriesMapped: [],
      reviewed: false,
      errors: {},
    };

    this.onEditorStateChangeQuestion = this.onEditorStateChangeQuestion.bind(this);
    this.onEditorStateChangeAnswer = this.onEditorStateChangeAnswer.bind(this);
    this.selectDifficulty = this.selectDifficulty.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.selectOffice = this.selectOffice.bind(this);
    this.handleChangeRevewied = this.handleChangeRevewied.bind(this);
    this.handleChangeGlobal = this.handleChangeGlobal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let update = {};
    if (nextProps.auth) {
      var tokenUserOffices = nextProps.auth.user.offices;
      update.singleOffice = tokenUserOffices && tokenUserOffices.length === 1 ? true : false;
      if (nextProps.questions && nextProps.questions.question) {
        if (nextProps.auth !== prevState.auth) {
          var dataToCheck = {
            isAuthenticated: nextProps.auth.isAuthenticated,
            user_type: nextProps.auth.user.type,
            root_link: `/admin/offices`,
            user_offices: nextProps.auth.user.offices,
            office_id: nextProps.match.params.officeId,
            previous_link: `/admin/${nextProps.match.params.officeId}/global-questions`,
            roles_allowed_to_write: [roles.SUPERADMINISTRATOR, roles.ADMINISTRATOR],
            page_type: pageType.WRITE,
            history: nextProps.history,
          };

          CheckPermissions(dataToCheck);

          if (nextProps.errors) {
            update.errors = nextProps.errors;
          }
          update.auth = nextProps.auth;
        }
        if (prevState.initialRender) {
          if (nextProps.questions.question !== prevState.questionDb) {
            var { question } = nextProps.questions;
            if (!isEmpty(question)) {
              const htmlQuestion = question.question;
              const questionValue = htmlToDraft(htmlQuestion);
              const questionState = ContentState.createFromBlockArray(questionValue.contentBlocks);
              const editorStateQuestion = EditorState.createWithContent(questionState);
              update.editorStateQuestion = editorStateQuestion;

              const htmlAnswer = question.answer;
              const answerValue = htmlToDraft(htmlAnswer);
              const answerState = ContentState.createFromBlockArray(answerValue.contentBlocks);
              const editorStateAnswer = EditorState.createWithContent(answerState);

              update.editorStateAnswer = editorStateAnswer;
              update.initialRender = false;
            }
          }
        }

        if (nextProps.offices && nextProps.offices.userOffices !== prevState.userOffices) {
          var { userOffices } = nextProps.offices;
          var officesMapped = [];
          userOffices.map((office) => {
            return officesMapped.push({
              id: office.id,
              title: `${office.value} - ${office.user_role_office.role.value}`,
            });
          });
          update.officesMapped = officesMapped;
        }
        if (nextProps.difficulties && nextProps.difficulties.difficulties) {
          if (nextProps.difficulties.difficulties !== prevState.difficulties) {
            var { difficulties } = nextProps.difficulties;
            var difficultiesMapped = [];
            difficulties.map((difficulty) => {
              return difficultiesMapped.push({ id: difficulty.id, title: difficulty.difficulty });
            });
            update.difficultiesMapped = difficultiesMapped;
          }
        }
        if (nextProps.categories && nextProps.categories.categories) {
          if (nextProps.categories.categories !== prevState.categories) {
            var { categories } = nextProps.categories;
            var categoriesMapped = [];
            categories.map((category) => {
              return categoriesMapped.push({ id: category.id, title: category.category });
            });
            update.categoriesMapped = categoriesMapped;
          }
        }
      }
    }
    return Object.keys(update).length ? update : null;
  }
  componentDidMount() {
    var dataToCheck = {
      isAuthenticated: this.props.auth.isAuthenticated,
      user_type: this.props.auth.user.type,
      root_link: `/admin/offices`,
      user_offices: this.props.auth.user.offices,
      office_id: this.props.match.params.officeId,
      previous_link: `/admin/${this.props.match.params.officeId}/global-questions`,
      roles_allowed_to_write: this.state.rolesAllowedToOpen,
      page_type: pageType.WRITE,
      history: this.props.history,
    };
    if (CheckPermissions(dataToCheck)) {
      this.props.getGlobalQuestion(this.props.match.params.questionId, this.props.match.params.officeId);
      this.props.getUserOffices(this.props.auth.user.id);
    }
  }
  componentWillUnmount() {
    this.props.clearErrors();
  }
  checkValidation() {
    this.props.clearErrors();
    var formData = {};
    if (this.state.office && !isNaN(this.state.office.id)) {
      formData.office_id = parseInt(this.state.office.id);
    }
    formData.user_id = this.props.auth.user.id;
    formData.question = draftToHtml(convertToRaw(this.state.editorStateQuestion.getCurrentContent()));
    formData.question_plain = this.state.editorStateQuestion.getCurrentContent().getPlainText();
    formData.answer = draftToHtml(convertToRaw(this.state.editorStateAnswer.getCurrentContent()));
    formData.answer_plain = this.state.editorStateAnswer.getCurrentContent().getPlainText();
    formData.difficulty_id = this.state.difficulty && this.state.difficulty.id ? this.state.difficulty.id : null;
    formData.category_id = this.state.category && this.state.category.id ? this.state.category.id : null;
    formData.global = this.state.global ? this.state.global : false;
    formData.reviewed = this.state.reviewed ? this.state.reviewed : false;
    formData.copy_question_id = this.props.match.params.questionId;

    const { errors } = QuestionValidation(formData);
    this.setState({ errors });
  }
  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.checkValidation();
    });
  }

  submitForm(e) {
    e.preventDefault();
    var formData = {};
    formData.question = draftToHtml(convertToRaw(this.state.editorStateQuestion.getCurrentContent()));
    formData.question_plain = this.state.editorStateQuestion.getCurrentContent().getPlainText();
    formData.answer = draftToHtml(convertToRaw(this.state.editorStateAnswer.getCurrentContent()));
    formData.answer_plain = this.state.editorStateAnswer.getCurrentContent().getPlainText();
    formData.difficulty_id = this.state.difficulty && this.state.difficulty.id ? this.state.difficulty.id : null;
    formData.category_id = this.state.category && this.state.category.id ? this.state.category.id : null;
    if (this.state.office && !isNaN(this.state.office.id)) {
      formData.office_id = parseInt(this.state.office.id);
    }

    formData.user_id = this.props.auth.user.id;
    formData.global = this.state.global ? this.state.global : false;
    formData.reviewed = this.state.reviewed ? this.state.reviewed : false;
    formData.copy_question_id = this.props.match.params.questionId;
    const { errors, isValid } = QuestionValidation(formData);
    if (isValid) {
      this.setState({ requestLoading: true });
      this.props.createQuestion(formData, (res) => {
        if (res.status === 200) {
          this.setState({ requestLoading: false });
          successToast("Question copied successfully");
          this.props.history.push(`/admin/${this.props.match.params.officeId}/global-questions`);
        } else {
          this.setState({ requestLoading: false });
          failToast("Question copying failed");
        }
      });
    } else {
      this.setState({ requestLoading: false });
      this.setState({ errors });
    }
  }

  handleChangeRevewied(reviewed) {
    this.setState({ reviewed });
  }
  handleChangeGlobal(global) {
    this.setState({ global });
  }
  onEditorStateChangeQuestion = (editorStateQuestion) => {
    this.setState(
      {
        editorStateQuestion,
      },
      () => {
        this.checkValidation();
      }
    );
  };
  onEditorStateChangeAnswer = (editorStateAnswer) => {
    this.setState(
      {
        editorStateAnswer,
      },
      () => {
        this.checkValidation();
      }
    );
  };
  selectDifficulty(value) {
    if (value.id === (this.state.difficulty && this.state.difficulty.id)) {
      value = [];
    }
    this.setState({ difficulty: value }, () => {
      this.checkValidation();
    });
  }
  selectCategory(value) {
    if (value.id === (this.state.category && this.state.category.id)) {
      value = [];
    }
    this.setState({ category: value }, () => {
      this.checkValidation();
    });
  }
  selectOffice(value) {
    if (value.id !== (this.state.office && this.state.office.id)) {
      this.setState({ office: value, difficulty: [], category: [] }, () => {
        this.props.getCategories(this.state.office.id, () => {});
        this.props.getDifficulties(this.state.office.id, () => {});
        this.checkValidation();
      });
    }
  }
  render() {
    const { editorStateQuestion, editorStateAnswer } = this.state;
    const { question, loading } = this.props.questions;
    var content;
    if (loading) {
      content = <Spinner />;
    } else {
      if (isEmpty(question)) {
        content = <div>No question with this ID</div>;
      } else {
        content = (
          <div className="question-container">
            <TextAreaEditor
              label={"Question*"}
              editorState={editorStateQuestion}
              placeholder={"Question"}
              onChange={this.onEditorStateChangeQuestion}
              validationMsg={[this.state.errors.question, this.props.errors.error]}
            />
            <TextAreaEditor
              label={"Answer*"}
              title={"Question"}
              placeholder={"Answer"}
              editorState={editorStateAnswer}
              onChange={this.onEditorStateChangeAnswer}
              validationMsg={[this.state.errors.answer]}
            />
            <SearchDropdown
              label={"Offices*"}
              placeholder={"Office"}
              value={this.state.office}
              name={"office_id"}
              validationMsg={[this.props.errors.errors, this.state.errors.office_id]}
              onChange={this.selectOffice}
              multiple={false}
              options={this.state.officesMapped}
            />
            <SearchDropdown
              label={"Categories"}
              placeholder={"Category"}
              value={this.state.category}
              name={"category_id"}
              validationMsg={this.state.errors.category_id}
              onChange={this.selectCategory}
              multiple={false}
              options={this.state.categoriesMapped}
              isRequired={false}
            />
            <SearchDropdown
              label={"Difficulties"}
              placeholder={"Difficulty"}
              value={this.state.difficulty}
              name={"difficulty_id"}
              validationMsg={this.state.errors.difficulty_id}
              onChange={this.selectDifficulty}
              multiple={false}
              options={this.state.difficultiesMapped}
            />
            <div className="default-flex">
              <Switch
                onChange={this.handleChangeRevewied}
                value={this.state.reviewed}
                id={"reviewed"}
                name={"reviewed"}
                label={"Reviewed"}
              />
            </div>

            <div className="submit-button">
              <Btn className="btn btn-primary " label="Submit" onClick={(e) => this.submitForm(e)} loading={this.state.requestLoading} />
            </div>
          </div>
        );
      }
    }
    return (
      <div className="grid-menu-container">
        <div className="menu-grid">
          <div className="menu">
            <SideMenuOffices props={this.props} />
            <hr />
            <SideMenu props={this.props} />
          </div>
        </div>
        <div className="main-grid">
          <div className="main">
            <div className="width-container">
              <Navigate title={"Copy Question"} link={`/admin/${this.props.match.params.officeId}/global-questions`} />
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CopyQuestion.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  questions: state.questions,
  difficulties: state.difficulties,
  categories: state.categories,
  offices: state.offices,
});

export default connect(mapStateToProps, {
  getGlobalQuestion,
  createQuestion,
  getCategories,
  getDifficulties,
  getUserOffices,
  clearErrors,
})(withRouter(CopyQuestion));
